// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._sbkvA5bAdpSAapvl6Dq{align-items:center;display:flex;flex-direction:row;justify-content:center;padding:15px;position:relative;z-index:9999999999}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeaderWrapper": `_sbkvA5bAdpSAapvl6Dq`
};
export default ___CSS_LOADER_EXPORT___;
